var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 19,
    viewBox: "0 0 65 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9023 0.271484H19.8923V18.7313H16.9023V0.271484Z",
    fill: "#0C111D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1899 12.6299C30.1899 15.4899 27.8499 15.7499 27.07 15.7499C25.25 15.7499 24.99 14.0599 24.99 13.1499V6H22V13.0199C22 14.7099 22.52 16.2699 23.56 17.1799C24.47 18.0899 25.64 18.4799 27.07 18.4799C28.1099 18.4799 29.4099 18.2199 30.1899 17.4399V18.4799H33.1799V6H30.1899V12.6299Z",
    fill: "#0C111D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1257 1.70117H36.1358V6.25113H33.9258V9.11111H36.1358V18.731H39.1257V9.11111H41.3357V6.25113H39.1257V1.70117Z",
    fill: "#0C111D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6993 14.9611C50.0493 15.4811 49.1393 15.8711 48.2293 15.8711C46.1493 15.8711 44.7194 14.3111 44.7194 12.2312C44.7194 10.1512 46.1493 8.72119 48.2293 8.72119C49.1393 8.72119 50.0493 8.98118 50.6993 9.63118L51.0893 10.0212L53.1693 8.07119L52.6493 7.68119C51.4793 6.6412 49.9193 5.99121 48.2293 5.99121C44.5894 5.99121 41.8594 8.72119 41.8594 12.3612C41.8594 16.0011 44.5894 18.7311 48.2293 18.7311C49.9193 18.7311 51.4793 18.0811 52.6493 17.0411L53.1693 16.6511L51.0893 14.5711L50.6993 14.9611Z",
    fill: "#0C111D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7015 7.29143C62.7915 6.38144 61.8815 5.99144 60.4515 5.99144C59.4115 5.99144 58.3715 6.25143 57.5915 7.03143V0.271484H54.6016V18.7313H57.5915V11.8414C57.5915 8.98141 59.5415 8.72141 60.3215 8.72141C62.1415 8.72141 62.0115 10.4114 62.0115 11.3214V18.6013H65.0015V11.4514C65.0015 9.76141 64.6115 8.20142 63.7015 7.29143Z",
    fill: "#0C111D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1034 14.4412C49.2522 14.4412 50.1834 13.51 50.1834 12.3612C50.1834 11.2125 49.2522 10.2812 48.1034 10.2812C46.9547 10.2812 46.0234 11.2125 46.0234 12.3612C46.0234 13.51 46.9547 14.4412 48.1034 14.4412Z",
    fill: "#EF4335"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7399 14.1815C11.6999 15.2215 10.1399 15.8715 8.44993 15.8715C5.19996 15.8715 2.85998 13.2715 2.85998 9.76154C2.85998 6.25157 5.19996 3.65159 8.57993 3.65159C10.1399 3.65159 11.6999 4.30159 12.8699 5.47158L13.2599 5.86157L15.2099 3.91159L14.8199 3.52159C13.1299 1.83161 10.9199 0.921614 8.57993 0.921614C3.63997 0.791615 0 4.69158 0 9.76154C0 14.8315 3.63997 18.7315 8.44993 18.7315C10.7899 18.7315 13.1299 17.8215 14.6899 16.1315L15.0799 15.7415L13.1299 13.7915L12.7399 14.1815Z",
    fill: "#0C111D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLogo);
export default __webpack_public_path__ + "static/media/client-logo.b3eb7dfdf6cfdbc21adc5b8b68df607c.svg";
export { ForwardRef as ReactComponent };